import {SectionBgView} from './SectionBgView'
import {PIXI} from '@colonist/pixi'
import {SpriteView} from './SpriteView'
import {GameFont} from '../GameFont'
import {TextView} from './TextView'
import {GameColor} from '../GameColor'
import {TranslationObject} from '@colonist/i18n'

export class RankedDivisionIconView extends SectionBgView {
    readonly divisionIcon: SpriteView
    readonly subdivisionIcon: SpriteView
    readonly topText: TextView

    constructor(centerX: number, y: number, w: number, h: number, container: PIXI.Container, divisionTexture: PIXI.Texture, subdivisionTexture: PIXI.Texture, topTextValue: TranslationObject) {
        const x = centerX - (w / 2)
        super(x, y, w, h, container)

        const iconWidth = h
        const iconHeight = h
        const textHeight = iconHeight / 5
        const textWidth = w * 5
        const textPaddingY = -1 * h / 3
        const topTextY = -0.5 * iconHeight - textHeight - textPaddingY

        this.divisionIcon = new SpriteView(0, 0, iconWidth, iconHeight, this, divisionTexture)
        this.divisionIcon.centerXInParent()

        const subdivisionIconY = this.divisionIcon.y + this.divisionIcon.height
        const iconScalar = 0.7
        const subdivisionHeight = iconHeight * iconScalar
        const subdivisionWidth = subdivisionHeight * subdivisionTexture.width / subdivisionTexture.height
        this.subdivisionIcon = new SpriteView(0, subdivisionIconY, subdivisionWidth, subdivisionHeight, this, subdivisionTexture)
        this.subdivisionIcon.centerXInParent()

        this.topText = new TextView(topTextValue, 0, topTextY, textWidth, textHeight, this, GameFont.Size.XL, GameColor.getColor(GameColor.Color.White))
        this.topText.centerXInParent()
    }
}
